import { useState } from 'react';

type GameType = 'Slots' | 'Live' | 'Tables';

const gameData = {
  Slots: {
    count: '2000+',
    description: 'From classic fruit machines to modern video slots with progressive jackpots',
    features: ['Megaways', 'Bonus Buy', 'Free Spins', 'Jackpot Games']
  },
  Live: {
    count: '150+',
    description: 'Real dealers, real-time action with HD streaming quality',
    features: ['Live Blackjack', 'Live Roulette', 'Live Baccarat', 'Game Shows']
  },
  Tables: {
    count: '100+',
    description: 'Classic table games with multiple variants and betting limits',
    features: ['Blackjack', 'Roulette', 'Baccarat', 'Poker Variants']
  }
};

export const GameMix: React.FC = () => {
  const [activeTab, setActiveTab] = useState<GameType>('Slots');

  return (
    <div className="glass-card p-6">
      <h3 className="text-2xl font-bold text-primary-green mb-4">Game Mix</h3>
      <div className="flex gap-2 mb-6 border-b border-primary-green/30">
        {(['Slots', 'Live', 'Tables'] as GameType[]).map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === tab
                ? 'text-primary-green border-b-2 border-primary-green'
                : 'text-gray-400 hover:text-primary-green'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>
      <div className="space-y-4">
        <div>
          <p className="text-3xl font-bold text-white mb-2">{gameData[activeTab].count}</p>
          <p className="text-gray-300">{gameData[activeTab].description}</p>
        </div>
        <div className="grid grid-cols-2 gap-2">
          {gameData[activeTab].features.map(feature => (
            <div
              key={feature}
              className="bg-black/50 border border-primary-green/20 rounded px-3 py-2 text-sm text-gray-300"
            >
              {feature}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

